<div class="header">
  <h1
    class="education-header-text"
    [ngClass]="{
      'changed-label':
        changes.entityAttributes.includes(jobseekerEnum.Education) && isEdited
    }"
  >
    {{ 'label.Education' | translate }}
  </h1>
</div>
<div class="container">
  <div
    class="education"
    [ngClass]="{
      'changed-label':
        checkAddedAndModifiedEducations(education.jobseekerEducationId) &&
        isEdited
    }"
    *ngFor="let education of educations"
  >
    <div class="education-info">
      <span *ngIf="education.educationLevel" class="education-level">{{
        education.educationLevel
      }}</span>
      <span class="education-period">{{
        (education.dateFromYear && education.dateFromMonth
          ? education.dateFromYear +
            ' ' +
            (education.dateFromMonth | numberToMonth)
          : education.dateFromYear) +
          ' ' +
          '-' +
          ' ' +
          (education.dateToYear && education.dateToMonth
            ? education.dateToYear +
              ' ' +
              (education.dateToMonth | numberToMonth)
            : education.dateToYear
            ? education.dateToYear
            : ('label.Present' | translate))
      }}</span>
      <span *ngIf="education.institution" class="education-institution">{{
        education.institution
      }}</span>
      <span *ngIf="education.educationalProgramName">{{
        education.educationalProgramName
      }}</span>
      <span *ngIf="education.specialization">{{
        education.specialization
      }}</span>
      <span *ngIf="education.description" class="education-description">{{
        education.description
      }}</span>
      <a
        *ngIf="education.filename"
        [href]="education.filename"
        class="attachment"
        target="_blank"
      >
        <svg-icon src="assets/img/attachment.svg"></svg-icon>
        <span class="attachment-label"
          >{{ 'label.Attachment' | translate }}
        </span>
      </a>
    </div>
    <app-reject-dialog
      *ngIf="
        checkAddedAndModifiedEducations(education.jobseekerEducationId) &&
        isEdited
      "
      [id]="education.objectId"
      (setDictionary)="reject($event)"
    ></app-reject-dialog>
  </div>
  <div
    class="deleted-education"
    *ngIf="
      isEdited &&
      changes.jobseekerEducationChanges?.removedEducations?.length &&
      changes.jobseekerEducationChanges?.removedEducations?.length > 0
    "
  >
    <div
      class="deleted-label education"
      *ngFor="
        let education of changes.jobseekerEducationChanges.removedEducations
      "
    >
      <div class="education-info">
        <span *ngIf="education.educationLevel.name" class="education-level">{{
          education.educationLevel.name
        }}</span>
        <span class="education-period">{{
          (education.dateFromYear && education.dateFromMonth
            ? education.dateFromYear +
              ' ' +
              (education.dateFromMonth | numberToMonth)
            : education.dateFromYear) +
            ' ' +
            '-' +
            ' ' +
            (education.dateToYear && education.dateToMonth
              ? education.dateToYear +
                ' ' +
                (education.dateToMonth | numberToMonth)
              : education.dateToYear
              ? education.dateToYear
              : ('label.Present' | translate))
        }}</span>
        <span *ngIf="education.institution" class="education-institution">{{
          education.institution
        }}</span>
        <span *ngIf="education.educationalProgramName">{{
          education.educationalProgramName
        }}</span>
        <span *ngIf="education.specialization">{{
          education.specialization
        }}</span>
        <span *ngIf="education.description" class="education-description">{{
          education.description
        }}</span>
        <a
          *ngIf="education?.attachment?.filename"
          [href]="education.attachment.filename"
          class="attachment"
          target="_blank"
        >
          <svg-icon src="assets/img/attachment.svg"></svg-icon>
          <span class="attachment-label"
            >{{ 'label.Attachment' | translate }}
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
